import React from 'react'
import PropTypes from 'prop-types'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Redirect } from 'react-router-dom'
import { GLOBAL_PATHS } from 'constants/paths'
import { ONLINE_STORE_BRAND_NAME } from 'constants/values'
import { PartnerSiteRedirectWrapper } from 'shared/components'
import Branding from 'shared/branding'

const UnifiedHomepagesRedirect = ({
  to = GLOBAL_PATHS.MFA,
  authProps,
}) => {
  const { redirectToP360 } = useFlags()
  const { key } = Branding.current

  if (redirectToP360 && key !== ONLINE_STORE_BRAND_NAME.P360) {
    return <PartnerSiteRedirectWrapper brand={key} authProps={authProps} />
  }
  return <Redirect to={to} />
}

UnifiedHomepagesRedirect.propTypes = {
  authProps: PropTypes.object,
  to: PropTypes.string,
}

export default UnifiedHomepagesRedirect
